import React from 'react';
import PropTypes from 'prop-types';

import Text from '../Text';

import { Container, Header, HeaderLink, Title, SubTitle, Image } from './styles';

const List = ({ children }) => (
  <Container>
    {children.map(({ id, title, position, text, link, image }) => {
      const Head = link ? HeaderLink : Header;
      const headProps = link ? { href: link } : {};

      return (
        <div key={id}>
          <Head {...headProps}>
            <Title>{title}</Title>
            {position && <SubTitle>{position}</SubTitle>}
          </Head>
          <Text>{text}</Text>
          {image && link && <Image href={link} $src={image} aria-label={link} />}
        </div>
      );
    })}
  </Container>
);

List.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      position: PropTypes.string,
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
      link: PropTypes.string,
      image: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default List;
